import Vue from 'vue'

const state = {
  listaConteudos: [],
  formatos: []
}

const mutations = {
  setConteudos (state, data) {
    state.listaConteudos = data
  },
  setFormatos (state, data) {
    state.formatos = data
  }
}

const actions = {
  buscarConteudos (context, config) {
    if (!config.page) {
      config.page = 1
    }

    if (!config.limit) {
      config.limit = 200
    }

    Vue.http.get('api/conteudo?length=' + config.limit + '&page=' + config.page).then(response => {
      context.commit('setConteudos', response.body.data.data)
    })
  },
  buscarFormatos (context) {
    Vue.http.get('api/conteudo-formatos').then(response => {
      context.commit('setFormatos', response.data.data)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/conteudo.js